import FeeIcon from './FeeIcon'

export default FeeIcon
